import projectWebSocketDebuggerImg from '../assets/images/project-websocket-debugger.jpg';
import projectCheatConsoleImg from '../assets/images/project-cheat-console.jpg';
import projectUtilsImg from '../assets/images/project-utils.jpg';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import '../assets/styles/Project.scss';

function Project() {
    return (
        <div className="projects-container" id="projects">
            <h1>Personal Projects</h1>
            <div className="projects-grid">
                <div className="project">
                    <div className="project-header">
                        <h2>WebSocket Debugger</h2>
                    </div>
                    <div className="project-image-container">
                        <a href="https://assetstore.unity.com/packages/tools/utilities/websocket-debugger-263325" target="_blank" rel="noreferrer">
                            <img src={projectWebSocketDebuggerImg} className="zoom" alt="WebSocket Debugger thumbnail" width="100%" />
                        </a>
                        <div className="project-description">
                            <p>The asset improves debugging of built applications. Issues often appear only after compilation, even if everything works in the editor. Instead of using Development Builds or custom logging, it connects the client (final build) to a server via WebSocket, allowing logs to be streamed and viewed on a computer. Client and server must be on the same network.</p>
                        </div>
                    </div>
                </div>
                <div className="project">
                    <div className="project-header">
                        <h2>
                            CheatConsole
                            <span className="separator"> | </span>
                            <a href={`${process.env.PUBLIC_URL}/docs/cheat-console-docs.pdf`} target="_blank" rel="noreferrer" className="docs-link"><InsertLinkIcon /> Docs</a>
                        </h2>
                    </div>
                    <div className="project-image-container">
                        <a href="#" target="_blank" rel="noreferrer">
                            <img src={projectCheatConsoleImg} className="zoom" alt="CheatConsole thumbnail" width="100%" />
                        </a>
                        <div className="project-description">
                            <p>Cheat Console is a plug-and-play in-game command tablet for Unity. Define commands in code, compile, and run them instantly in-game. Perfect for fast debugging, testing, and QA.</p>
                        </div>
                    </div>
                </div>
                <div className="project">
                    <div className="project-header">
                        <h2>Utils</h2>
                    </div>
                    <div className="project-image-container">
                        <a href="https://github.com/pawbab0/Utils" target="_blank" rel="noreferrer">
                            <img src={projectUtilsImg} className="zoom" alt="Utils thumbnail" width="100%" />
                        </a>
                        <div className="project-description">
                            <p>A collection of practical Unity utilities and programming tools designed to streamline development workflows. This open-source project includes extensions, reusable components, and design pattern implementations aimed at improving code quality, modularity, and productivity.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Project;